import { createContext, ReactNode, useState } from "react";

interface ProductProviderProps {
  children: ReactNode | ReactNode[];
}

interface ProductContextProps {
  activeProduct: string;
  setActiveProduct: (product: string) => void;
}

const ProductContext = createContext<ProductContextProps>(
  {} as ProductContextProps
);

const ProductProvider: React.FC<ProductProviderProps> = ({ children }) => {
  const [activeProduct, setActiveProduct] = useState("");

  return (
    <ProductContext.Provider value={{ activeProduct, setActiveProduct }}>
      {children}
    </ProductContext.Provider>
  );
};

export { ProductContext, ProductProvider };
